export default __webpack_public_path__ + "static/media/signature-denise.485680c7.jpg";